// ParagraphOverlayPulseButton.tsx
import React from 'react';
import { IconButton } from '@fluentui/react';
import { TbTextScan2 } from 'react-icons/tb';
import styles from './ParagraphOverlayPulseButton.module.css';

type ParagraphOverlayPulseButtonProps = {
    showParagraphOverlay: boolean;
    setShowParagraphOverlay: React.Dispatch<React.SetStateAction<boolean>>;
    zoomInOutViewer: any;
    buttonClassName?: string;
    size?: number;
};

export default function ParagraphOverlayPulseButton({
    showParagraphOverlay,
    setShowParagraphOverlay,
    zoomInOutViewer,
    buttonClassName = '',
    size = 20
}: ParagraphOverlayPulseButtonProps) {
    return (
        <IconButton
            className={`${buttonClassName} ${styles.button}`}
            styles={zoomInOutViewer}
            onClick={() => setShowParagraphOverlay(prev => !prev)}
        >
            <span className={`${styles.iconStack} ${showParagraphOverlay ? styles.active : ''}`}>
                <TbTextScan2
                    size={size}
                    className={`${styles.pulseLayer} ${styles.pulseLayer1}`}
                    aria-hidden="true"
                />
                <TbTextScan2
                    size={size}
                    className={`${styles.pulseLayer} ${styles.pulseLayer2}`}
                    aria-hidden="true"
                />
                <TbTextScan2
                    size={size}
                    className={styles.icon}
                    style={{ opacity: showParagraphOverlay ? 1 : 0.5 }}
                />
            </span>
        </IconButton>
    );
}